import {
  sendEventToGoogleAnalytics,
  sendPageViewToGoogleAnalytics,
} from './googleAnalyticsProvider';
import { AnalyticsParams } from './analytics.types';
import { setEventEmitter } from './eventEmitters/eventEmitters.utils';

interface AnalyticsEvent{
    event_category: string;
    event_action: string;
    event_label: string;
    [key: string]: any;
}

function sendPageView(params: AnalyticsParams) {
  sendPageViewToGoogleAnalytics(params);
}

function extractGAParams(params: AnalyticsEvent) {
  const { event_category, event_action, event_label, ...additionalParams } = params;
  sendEventToGoogleAnalytics(event_category, event_action, event_label, additionalParams);
}

export function analyticsEventEmitter() {
  setEventEmitter('analytics', (params: AnalyticsEvent) => extractGAParams(params));
}

export function initAnalytics(params: AnalyticsParams) {
  sendPageView(params);
  analyticsEventEmitter();
}
